module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "questionForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.questionForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Question",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.questionForm.title),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "title", $$v)
      },
      expression: "questionForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select category",
      "filterable": ""
    },
    model: {
      value: (_vm.questionForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "categoryId", $$v)
      },
      expression: "questionForm.categoryId"
    }
  }, _vm._l((_vm.questionCategoryList), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.title,
        "value": category.id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "icon": "el-icon-plus",
      "circle": "",
      "size": "small"
    },
    on: {
      "click": _vm.handleAddCategory
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Question type",
      "prop": "questionType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select type"
    },
    on: {
      "change": _vm.handleQuestionTypeChange
    },
    model: {
      value: (_vm.questionForm.questionType),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "questionType", $$v)
      },
      expression: "questionForm.questionType"
    }
  }, _vm._l((_vm.questionTypeList), function(type) {
    return _c('el-option', {
      key: type.value,
      attrs: {
        "label": type.title,
        "value": type.value
      }
    })
  }), 1)], 1), _vm._v(" "), (['SCALE', 'SELECT', 'MULTI_SELECT'].includes(_vm.questionForm.questionType)) ? _c('el-form-item', {
    attrs: {
      "label": "Chart type",
      "prop": "chart"
    }
  }, [_c('div', [_c('el-radio', {
    attrs: {
      "label": "PIE"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Pie")])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "DONUT"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Donut")])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "VERTICAL_BAR"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Vertical bar")])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "HORIZONTAL_BAR"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Horizontal bar")])], 1), _vm._v(" "), _c('help-text', [_vm._v("Which kind of chart would best display the results of this question?")])], 1) : _vm._e(), _vm._v(" "), (_vm.questionForm.questionType === 'SCALE') ? _c('el-form-item', {
    attrs: {
      "label": "Insight",
      "prop": "insight"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.questionForm.insight),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "insight", $$v)
      },
      expression: "questionForm.insight"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("\n        This is for providing a story on one sheets, Available variable substitutions are\n        {positive_percentage} {positive_cume} {positive_total}.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isRequired"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Required"
    },
    model: {
      value: (_vm.questionForm.isRequired),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "isRequired", $$v)
      },
      expression: "questionForm.isRequired"
    }
  })], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isProfile"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Store as audience profile information"
    },
    model: {
      value: (_vm.questionForm.isProfile),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "isProfile", $$v)
      },
      expression: "questionForm.isProfile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questionForm.isProfile),
      expression: "questionForm.isProfile"
    }],
    attrs: {
      "label": "Profile field",
      "prop": "profileField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select profile field",
      "filterable": ""
    },
    model: {
      value: (_vm.questionForm.profileField),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "profileField", $$v)
      },
      expression: "questionForm.profileField"
    }
  }, _vm._l((_vm.questionProfileFieldList), function(field) {
    return _c('el-option', {
      key: field.value,
      attrs: {
        "label": field.label,
        "value": field.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.me.is_staff) ? _c('div', [_c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Staff options")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isGlobal"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Is global question",
      "disabled": _vm.questionDialogAddToCanvas || _vm.questionForm.id
    },
    model: {
      value: (_vm.questionForm.isGlobal),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "isGlobal", $$v)
      },
      expression: "questionForm.isGlobal"
    }
  }), _vm._v(" "), (_vm.questionDialogAddToCanvas) ? _c('help-text', [_vm._v("\n          (Disabled: Use the\n          "), _c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" button on the question selector to add this question,\n          if you need global)\n        ")]) : _vm._e(), _vm._v(" "), (_vm.questionForm.id) ? _c('help-text', [_vm._v("(Disabled: this can only be set on new questions)")]) : _vm._e(), _vm._v(" "), _c('help-text', [_vm._v("Should this question be available to all companies (green question)")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.questionsCreating
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.questionForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-437a68c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/dialogs/QuestionSaveDialog.vue
// module id = 3251
// module chunks = 3